<div class="entity-config-detail-page container-fluid px-2 px-md-3 py-1">
  <div class="entity-config-shell d-flex flex-column gap-2 mx-auto">
    <section class="entity-detail-hero-shell rounded-4 shadow-sm overflow-hidden">
      <div class="bg-transparent px-3 px-md-3 pt-1 pb-0">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-detail-title-vibrant text-white fw-bold lh-sm mb-1">
              {{ entity_type_name }} Entity
            </h1>
            <p class="entity-detail-subcopy text-white mb-0">
              {{ entity_description }}
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <div class="d-flex d-sm-inline-flex">
              <button
                type="button"
                class="btn btn-light rounded-3 shadow-sm d-inline-flex align-items-center justify-content-center entity-action-btn border-0 text-white text-nowrap"
                @click="go_to_bind_subsystems"
              >
                <i class="bi bi-link-45deg me-2 text-white"></i>
                Bind Subsystems
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-2 entity-detail-metric-wrap">
        <div class="row g-2 entity-detail-top-metrics">
          <div
            v-for="item in summary_items"
            :key="item.label"
            class="col-12 col-sm-6 col-xl-4 col-xxl-3"
          >
            <article class="entity-metric-card rounded-4 p-3 h-100">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex flex-column justify-content-start pt-1 ps-2">
                  <span class="entity-metric-label secondary-color text-uppercase fw-bold d-block mb-2">{{ item.label }}</span>
                  <div class="entity-metric-value secondary-color fw-bold lh-1 mb-0 mt-1">{{ item.count }}</div>
                </div>
                <div class="entity-metric-icon rounded-3 d-inline-flex align-items-center justify-content-center mt-2 me-1 text-white">
                  <i class="bi" :class="item.icon"></i>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <section class="row g-2">
      <div class="col-12 col-xl-8">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <div>
              <h2 class="fs-6 fw-bold mb-1">Active Configuration Bindings</h2>
              <div class="entity-panel-caption small fw-semibold">Core orchestration bindings for this entity.</div>
            </div>
            <div class="d-flex align-items-center gap-2 text-secondary">
              <i class="bi bi-funnel small"></i>
              <i class="bi bi-three-dots-vertical small"></i>
            </div>
          </div>

          <div class="entity-binding-card-grid">
            <article
              v-for="card in binding_cards"
              :key="card.key"
              class="entity-vibrant-binding-card rounded-4 p-3 bg-white bg-opacity-75"
            >
              <div class="d-flex align-items-start justify-content-between gap-3 mb-2">
                <div class="d-flex align-items-start gap-3">
                  <div
                    class="entity-summary-icon entity-config-binding-system-icon rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0"
                  >
                    <i class="bi" :class="card.icon"></i>
                  </div>
                  <div>
                    <div class="fw-bold small mb-1">{{ card.title }}</div>
                    <div class="small text-secondary">{{ card.description }}</div>
                  </div>
                </div>
                <span class="entity-detail-pill rounded-pill fw-bold text-uppercase" :class="card.statusClass">
                  {{ card.statusText }}
                </span>
              </div>
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-secondary">{{ card.footerText }}</div>
                <button
                  type="button"
                  class="btn btn-link p-0 text-decoration-none small fw-semibold entity-binding-card-link"
                  @click="open_binding_card(card)"
                >
                  {{ card.actionLabel }} <i class="bi bi-arrow-right-short"></i>
                </button>
              </div>
            </article>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="entity-detail-panel entity-detail-panel-vibrant rounded-4 border shadow-sm p-3 h-100">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-3">
            <h2 class="fs-6 fw-bold mb-0">Recent Activity</h2>
            <i class="bi bi-filter text-secondary small"></i>
          </div>

          <div v-if="recent_activities.length" class="entity-activity-timeline">
            <div
              v-for="activity in recent_activities"
              :key="activity.id"
              class="entity-activity-item"
            >
              <span class="entity-activity-dot" :class="activity.toneClass"></span>
              <div class="entity-activity-card rounded-3 px-3 py-2">
                <div class="d-flex align-items-start justify-content-between gap-2 mb-1">
                  <div class="entity-activity-title fw-bold">{{ activity.title }}</div>
                  <div class="entity-activity-time text-secondary">{{ activity.timestamp }}</div>
                </div>
                <div class="entity-activity-reason text-secondary">{{ activity.reason }}</div>
              </div>
            </div>
          </div>

          <div v-else class="small text-secondary">
            No recent orchestration activity yet.
          </div>

          <button type="button" class="btn btn-light w-100 mt-3 rounded-small border entity-audit-btn">View Full Audit Log</button>
        </div>
      </div>
    </section>

  </div>
</div>
